define("settings/routes/groups/group/social_profiles", ["exports", "ember-concurrency/async-arrow-runtime", "@ember/object", "@ember/routing/route", "@ember/service", "@ember/utils", "@glimmer/tracking", "ember-concurrency", "later/utils/object-promise-proxy", "shared/utils/has-linkinbio-feed-block"], function (_exports, _asyncArrowRuntime, _object, _route, _service, _utils, _tracking, _emberConcurrency, _objectPromiseProxy, _hasLinkinbioFeedBlock) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _destroySocialProfile;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"@ember/object",0,"@ember/routing/route",0,"@ember/service",0,"@ember/utils",0,"@glimmer/tracking",0,"ember-concurrency",0,"later/utils/object-promise-proxy",0,"shared/utils/has-linkinbio-feed-block"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
  function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _classPrivateMethodGet(s, a, r) { return _assertClassBrand(a, s), r; }
  function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  let SocialProfilesRoute = _exports.default = (_class = (_destroySocialProfile = /*#__PURE__*/new WeakSet(), class SocialProfilesRoute extends _route.default {
    constructor() {
      super(...arguments);
      _classPrivateMethodInitSpec(this, _destroySocialProfile);
      _initializerDefineProperty(this, "alerts", _descriptor, this);
      _initializerDefineProperty(this, "dialogManager", _descriptor2, this);
      _initializerDefineProperty(this, "errors", _descriptor3, this);
      _initializerDefineProperty(this, "intl", _descriptor4, this);
      _initializerDefineProperty(this, "settings", _descriptor5, this);
      _initializerDefineProperty(this, "store", _descriptor6, this);
      _defineProperty(this, "queryParams", {
        profile: {
          refreshModel: true
        },
        nickname: {}
      });
      _initializerDefineProperty(this, "hasAuthedNewSocialProfile", _descriptor7, this);
      _defineProperty(this, "removeSocialProfile", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* (socialProfile, group) {
          const socialIdentity = yield (0, _objectPromiseProxy.objectPromiseProxy)(socialProfile.get('socialIdentity'));
          const profileDescription = yield this.profileDescription.perform(socialProfile, socialIdentity, group);
          const description = profileDescription ? profileDescription : this.intl.t('account.groups.group.social_profiles.remove.confirm', {
            name: socialProfile.displayName
          });
          yield this.dialogManager.confirm(this.intl.t('account.groups.group.social_profiles.remove.confirm_title'), {
            description,
            confirmButton: this.intl.t('shared_words.remove')
          });
          try {
            const {
              alert
            } = yield this.settings.submitForm.perform(_classPrivateMethodGet(this, _destroySocialProfile, _destroySocialProfile2).call(this, socialProfile), 'account.groups.group.social_profiles.remove');
            if (socialIdentity.get('socialProfiles').length == 0) {
              if (!socialIdentity.influencerId) {
                group.get('socialIdentities').removeObject(socialIdentity);
                yield socialIdentity.deleteRecord();
                yield socialIdentity.unloadRecord();
              }
            }
            group.get('socialProfiles').removeObject(socialProfile);
            this.send('handleUpdate');
            this.alerts.add(alert);
          } catch ({
            alert
          }) {
            this.alerts.add(alert);
          }
        }
      }), null, "removeSocialProfile", "drop"));
      _defineProperty(this, "profileDescription", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* (socialProfile, socialIdentity, group) {
          const baseDescription = this.intl.t('account.groups.group.social_profiles.remove.confirm', {
            name: socialProfile.displayName
          });
          const linkinbioDescription = yield this.linkinbioDescription.perform(baseDescription, socialProfile, group);
          const creatorDescription = yield this.creatorDescription.perform(linkinbioDescription, socialProfile, socialIdentity);
          return creatorDescription;
        }
      }), null, "profileDescription", null));
      _defineProperty(this, "creatorDescription", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* (linkinbioDescription, socialProfile, socialIdentity) {
          try {
            const influencer = yield (0, _objectPromiseProxy.objectPromiseProxy)(socialIdentity.get('influencer'));
            if (socialIdentity.influencerId && influencer.optedInAt) {
              const activeCampaigns = yield influencer.manageCampaigns({
                status: 'active'
              });
              const appliedCampaigns = yield influencer.manageCampaigns({
                status: 'applied'
              });
              const isRequiredProfile = socialProfile.isInstagram || socialProfile.isFacebook;
              let creatorDescription = this.intl.t('account.groups.group.social_profiles.remove.confirm_creator_profile');
              if (isRequiredProfile) {
                creatorDescription = creatorDescription.concat('<br/><br/>', this.intl.t('account.groups.group.social_profiles.remove.confirm_creator_required_applicant'));
              }
              if ((0, _utils.isPresent)(activeCampaigns.campaign) || (0, _utils.isPresent)(appliedCampaigns.campaign)) {
                creatorDescription = creatorDescription.concat('<br/><br/>', this.intl.t('account.groups.group.social_profiles.remove.confirm_creator_required_campaign'));
              }
              return linkinbioDescription.concat('<br/><br/>', creatorDescription);
            }
            return linkinbioDescription;
          } catch (error) {
            this.errors.log(error);
          }
        }
      }), null, "creatorDescription", null));
      _defineProperty(this, "linkinbioDescription", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* (baseDescription, socialProfile, group) {
          yield (0, _objectPromiseProxy.arrayPromiseProxy)(group.get('linkinbioPages').toArray());
          const page = socialProfile.get('linkinbioPage');
          const linkinbioEnabled = (0, _hasLinkinbioFeedBlock.hasLinkinbioFeedBlock)(page, socialProfile);
          if (linkinbioEnabled) {
            const linkinbioDescription = this.intl.t('account.groups.group.social_profiles.remove.confirm_linkinbio_enabled', {
              url: page.get('urlName')
            });
            return baseDescription.concat('<br/><br/>', linkinbioDescription);
          }
          return baseDescription;
        }
      }), null, "linkinbioDescription", null));
    }
    model(_ref) {
      let {
        new_social_profile_id,
        profile
      } = _ref;
      this.hasAuthedNewSocialProfile = !!new_social_profile_id;
      if (this.hasAuthedNewSocialProfile) {
        return this.store.peekRecord('social-profile', new_social_profile_id) || this.store.findRecord('social-profile', new_social_profile_id);
      }
      if (!profile) {
        return undefined;
      }
      return this.store.peekRecord('social-profile', profile) || this.store.findRecord('social-profile', profile);
    }
    setupController(controller, model) {
      controller.setProperties({
        group: this.modelFor('groups.group'),
        showProfileCategorizationModal: null,
        socialProfile: model,
        removeSocialProfile: this.removeSocialProfile
      });
    }
    handleUpdate() {
      this.refresh();
    }
  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "dialogManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "settings", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "store", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "hasAuthedNewSocialProfile", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "handleUpdate", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleUpdate"), _class.prototype)), _class);
  function _destroySocialProfile2(socialProfile) {
    socialProfile.deleteRecord();
    return socialProfile.save();
  }
});